import React from "react";
import { Grid, Typography, Box, Paper, Divider } from "@mui/material";
import Plot from "react-plotly.js";

export default function HourlyVisibilityLineGraph({ data }) {
  if (!data || Object.keys(data).length === 0) {
    return (
      <Box mt={3}>
        <Typography variant="h6" color="textSecondary">
          No data available to display Line Graphs.
        </Typography>
      </Box>
    );
  }

  return (
    <Box mt={3} sx={{ width: "100%" }}>
      {Object.entries(data).map(([billboardId, values]) => {
        const hourEntries = Object.entries(values.hourly_data)
          .map(([hour, val]) => {
            const cleanedHour = hour.replace(/:$/, ""); // remove trailing colon if any
            return { hour: cleanedHour, data: val };
          })
          .sort(
            (a, b) =>
              parseInt(a.hour.split(":")[0], 10) -
              parseInt(b.hour.split(":")[0], 10)
          );

        const sortedHours = hourEntries.map((entry) => entry.hour);
        const avgDurations = hourEntries.map(
          (entry) => entry.data.avg_duration
        );
        const avgSpeeds = hourEntries.map((entry) =>
          typeof entry.data.avg_speed === "number"
            ? entry.data.avg_speed * 3.6
            : entry.data.avg_speed
        );

        return (
          <Grid container justifyContent="center" key={billboardId}>
            <Grid item xs={12} md={10}>
              <Paper
                elevation={4}
                sx={{
                  p: 3,
                  mb: 4,
                  borderRadius: 3,
                  backgroundColor: "#f9f9f9",
                }}
              >
                <Typography
                  variant="h6"
                  sx={{ mb: 2, color: "primary.main", fontWeight: 600 }}
                >
                  ID: {billboardId}, {values.location}, {values.height} X{" "}
                  {values.width}
                </Typography>
                <Divider sx={{ mb: 2 }} />

                {/* Combined Graph for Visibility Duration and Speed */}
                <Box
                  sx={{
                    backgroundColor: "#fff",
                    p: 2,
                    borderRadius: 2,
                    boxShadow: 2,
                    width: "100%",
                  }}
                >
                  <Typography
                    variant="subtitle1"
                    sx={{ mb: 1, color: "grey.700" }}
                  >
                    Hourly Average Visibility Duration & Speed
                  </Typography>
                  <Plot
                    data={[
                      {
                        x: sortedHours,
                        y: avgDurations,
                        type: "scatter",
                        mode: "lines+markers",
                        name: "Avg Visibility Duration (s)",
                        line: { color: "#1565c0" },
                        yaxis: "y1",
                      },
                      {
                        x: sortedHours,
                        y: avgSpeeds,
                        type: "scatter",
                        mode: "lines+markers",
                        name: "Avg Speed (km/h)",
                        line: { color: "#d84315" },
                        yaxis: "y2",
                      },
                    ]}
                    layout={{
                      autosize: true,
                      margin: { t: 20, l: 50, r: 50, b: 50 },
                      xaxis: { title: "Time (Hour)", tickangle: -45 },
                      yaxis: {
                        title: "Avg Visibility Duration (s)",
                        side: "left",
                        color: "#1565c0",
                      },
                      yaxis2: {
                        title: "Avg Speed (km/h)",
                        side: "right",
                        overlaying: "y",
                        color: "#d84315",
                      },
                      paper_bgcolor: "#fff",
                      plot_bgcolor: "#fff",
                    }}
                    useResizeHandler={true}
                    style={{ width: "100%", height: "400px" }}
                    config={{
                      displayModeBar: true,
                      displaylogo: false,
                      responsive: true,
                    }}
                  />
                </Box>
              </Paper>
            </Grid>
          </Grid>
        );
      })}
    </Box>
  );
}
